export default __webpack_public_path__ + "static/media/expressjs.21708e53.svg";